import {Injectable} from '@angular/core';
import {SaleModel} from '../../api/entity/sale.model';
import {SaleRepository} from './ngrx/Sale.repository';
import {SaleDataServiceAdapter} from './ngrx/SaleDataService.adapter';
import {AbstractFindOneByIdService} from '../../../core/service/v2/service/findone/abstractFindOneById.service';

@Injectable()
export class SaleFindOneByIdService extends AbstractFindOneByIdService<SaleModel, SaleModel> {

    constructor(repository: SaleRepository, dataServiceAdapter: SaleDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
